module.exports = __webpack_public_path__ + "img/sqzs2023.c481b450.png";